<div *ngIf="isLoading" class="loading">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
<div style="text-align: center" *ngIf="!isLoading && !(data?.templates?.length > 0)">
  {{ "widget.noData" | translate }}
</div>
<table *ngIf="!isLoading && data?.templates?.length" mat-table [dataSource]="data.templates" style="width: 100%">
  <ng-container matColumnDef="practitioner">
    <th mat-header-cell *matHeaderCellDef>{{ "forms.doctor" | translate }}</th>
    <td mat-cell *matCellDef="let element">{{ element.practitioner.display }}</td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>{{ "forms.prescriptionTemplate.templateName" | translate }}</th>
    <td mat-cell *matCellDef="let element" style="text-align: center; padding: 10px">{{ element.name }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>{{ "table.actions" | translate }}</th>
    <td mat-cell *matCellDef="let element">
      <button mat-stroked-button (click)="validate(element)" class="validateBtn">
        <mat-icon class="fa-icon success" fontSet="fas" fontIcon="fa-check"></mat-icon>
      </button>
      <button
        mat-stroked-button
        (click)="onDelete(element)"
        class="deleteBtn"
        *ngIf="('dashboard/practitionerTemplate' | isAuthorized : 'DELETE' | async) === true"
      >
        <mat-icon class="custom-icon-small sub-align fail">delete</mat-icon>
      </button>
    </td></ng-container
  >
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 1rem">
  <div class="when-input">
    <p>{{ "forms.prescription.importTemplateFormat" | translate }}</p>
  </div>
  <button
    class="mt-1"
    type="button"
    style="float: right"
    mat-raised-button
    (click)="fileInput.click()"
    *ngIf="('dashboard/practitionerTemplate' | isAuthorized : 'POST' | async) === true"
  >
    {{ "forms.prescription.importTemplateBtn" | translate }}
  </button>
  <input hidden (change)="import($event)" #fileInput type="file" accept="application/pdf,image/jpg,image/jpeg,image/png" size="5000000" />
</div>
